/**
 * Quick-add for product cards.
 *
 * Strategy:
 * 1. Intercept submit on forms with data-product-card-form.
 * 2. POST to /cart/add.js (AJAX).
 * 3. Dispatch a battery of cart-update events that any cart drawer app
 *    (Upsell by AMP, Rebuy, native cart drawer, etc.) is likely to listen to.
 * 4. Best-effort fallback: click the cart icon to nudge the drawer open.
 *
 * If JS fails or is blocked, the form submits normally and the user lands
 * on /cart — non-broken fallback.
 */
(function () {
  if (typeof window === 'undefined') return;

  function showSpinner(button) {
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    button.disabled = true;
  }

  function hideSpinner(button) {
    button.removeAttribute('aria-busy');
    button.classList.remove('is-loading');
    button.disabled = false;
  }

  function flashState(button, label, ms) {
    var labelEl = button.querySelector('.product-card-button__label');
    if (!labelEl) return;
    var original = labelEl.textContent;
    labelEl.textContent = label;
    setTimeout(function () { labelEl.textContent = original; }, ms || 1800);
  }

  function dispatchCartUpdate(detail) {
    // Common event names different cart drawer apps listen to.
    var events = [
      'cart:added',
      'cart:refresh',
      'cart:updated',
      'cart:open',
      'cart-drawer:open',
      'on:cart:add',
    ];
    events.forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    });

    // Push to dataLayer for GTM (mirror Shopify's add_to_cart event)
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'add_to_cart',
        location: 'product_card_quickadd',
        ecommerce: {
          items: [{
            item_id: detail.product_id,
            item_name: detail.product_title,
            quantity: 1,
            price: detail.price ? detail.price / 100 : undefined,
          }],
        },
      });
    }
  }

  function tryOpenCartDrawer() {
    // Common selectors for cart drawer triggers (header cart icons, etc.)
    var selectors = [
      '[data-cart-drawer-trigger]',
      '[data-cart-toggle]',
      '.cart-icon-bubble',
      '.header__icon--cart',
      'a[href="/cart"]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        // Clicking the cart icon usually opens drawer in modern themes
        // Don't follow the link; just dispatch click event
        var event = new MouseEvent('click', { bubbles: true, cancelable: true });
        el.dispatchEvent(event);
        break;
      }
    }
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!form || !form.matches('form[data-product-card-form]')) return;

    e.preventDefault();
    e.stopPropagation();

    var button = form.querySelector('[data-product-card-quickadd]');
    var variantId = form.querySelector('input[name="id"]').value;
    var productId = form.dataset.productId;
    var productTitle = form.dataset.productTitle;

    if (!variantId) return;

    if (button) showSpinner(button);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var detail = {
          product_id: productId,
          product_title: productTitle,
          variant_id: variantId,
          price: data.items && data.items[0] ? data.items[0].price : undefined,
          source: 'product_card_quickadd',
        };
        dispatchCartUpdate(detail);

        // Try to open cart drawer (best effort — silent if no drawer)
        setTimeout(tryOpenCartDrawer, 100);

        if (button) {
          hideSpinner(button);
          flashState(button, '¡Agregado!');
        }
      })
      .catch(function (err) {
        console.warn('[quickadd] AJAX failed, falling back to native submit:', err);
        if (button) hideSpinner(button);
        // Fallback: submit the form natively so user still gets to cart
        form.removeEventListener('submit', handleSubmit, true);
        form.submit();
      });
  }

  // Listen on document level so newly inserted cards (Boost AI re-renders,
  // pagination, etc.) work without re-binding.
  document.addEventListener('submit', handleSubmit, true);
})();
